import { Component, Input, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs';
import { DashboardKpiService } from '../../../services/dashboard-kpi.service';
import { SalesSummaryEntity, Timespan } from '../../../types';

@Component({
    selector: 'lib-last-vs-this-month-sales-amount-summary-card',
    templateUrl: './last-vs-this-month-sales-amount-summary-card.component.html',
    styleUrls: ['./last-vs-this-month-sales-amount-summary-card.component.scss'],
    standalone: false
})
export class LastVsThisMonthSalesAmountSummaryCardComponent implements OnInit {
  salesAmountThisMonth = 0;
  salesAmountLastMonth = 0;
  loaded = false;

  @Input()
  preConditions: any;

  constructor(protected dashboardKpiService: DashboardKpiService) {}

  ngOnInit() {
    const thisMonthSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.Month);
    const lastMonthSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.LastMonth);

    forkJoin({
      salesSummaryGroupsThisMonth: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, thisMonthSpan.fromDate, null, this.preConditions)
        .pipe(first()),
      salesSummaryGroupsLastMonth: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, lastMonthSpan.fromDate, lastMonthSpan.toDate, this.preConditions)
        .pipe(first())
    }).subscribe(({ salesSummaryGroupsThisMonth, salesSummaryGroupsLastMonth }) => {
      this.salesAmountThisMonth = salesSummaryGroupsThisMonth.reduce((acc, curr) => acc + curr.totalAmount, 0);
      this.salesAmountLastMonth = salesSummaryGroupsLastMonth.reduce((acc, curr) => acc + curr.totalAmount, 0);
      this.loaded = true;
    });
  }
}
